import { Box, CircularProgress, Typography } from '@mui/material';

interface CircularProgressWithLabelProps {
  value: number;
  size?: number;
  labelPosition?: 'inside' | 'left' | 'right';
}

export function CircularProgressWithLabel({
  value,
  size = 40,
  labelPosition = 'inside',
}: CircularProgressWithLabelProps) {
  const labelText = `${Math.round(value > 0 && value < 1 ? 1 : value)}%`;

  if (labelPosition === 'left') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          sx={{ fontSize: '0.75rem', color: 'inherit' }}
        >
          {labelText}
        </Typography>
        <CircularProgress variant="determinate" value={value} size={size} thickness={4} />
      </Box>
    );
  }

  if (labelPosition === 'right') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress variant="determinate" value={value} size={size} thickness={4} />
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          sx={{ fontSize: '0.75rem' }}
        >
          {labelText}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" value={value} size={size} thickness={4} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          sx={{ fontSize: '0.75rem' }}
        >
          {labelText}
        </Typography>
      </Box>
    </Box>
  );
}
